import React, { Component, PropTypes } from 'react';
import Pagination from 'components/icons/Pagination';

class SlideshowNext extends Component {
  static propTypes = {
    color: PropTypes.string,
    direction: PropTypes.string
  }

  static defaultProps = {
    color: '#000',
    direction: 'left'
  }

  render() {
    const { color, direction } = this.props;

    return (
      <div className="SlideshowIcon">
        <Pagination direction={direction} color={color}/>
      </div>
    );
  }
}

export default SlideshowNext;



// WEBPACK FOOTER //
// ./app/components/icons/Slideshow.js